<section>
    <div class="container-xxl mb-3 pt-13 text-center">
        <p class="col-8 mx-auto">
            {{ 'CONFIGURATOR.regulations_info_v1' | translate }}
            <a [routerLink]="['/legal', 'regulations'] | localize" target="_blank">
                <u>{{ 'CONFIGURATOR.regulations' | translate }}</u>
            </a>
            {{ 'CONFIGURATOR.regulations_info_v2' | translate }}
        </p>
    </div>
</section>

@if ((euro$ | async) !== null) {
    <section class="mb-13 mb-md-14 pt-10">
        <app-metrix-configurator [snapshotId]="snapshotId$ | async" [euroRate]="(euro$ | async)!" />
    </section>
}

@if (snapshots$ | async; as snapshots) {
    <section class="py-10 mb-md-14">
        <app-example-products [snapshots]="snapshots" />
    </section>
}

<section class="bg-gray-150 py-10 mb-md-14">
    <app-similar-style />
</section>

<section class="py-10 mb-md-14">
    <app-awarded-collections />
</section>

<section class="mb-10 mb-md-14">
    <app-our-showroom />
</section>
